import useCancellablePromises from './useCancellablePromises'

const cancellablePromise = (promise: any) => {
    let isCanceled = false

    const wrappedPromise = new Promise(async (resolve, reject) => {
        try {
            const value = await promise
            if (isCanceled) {
                reject({ isCanceled, value })
            } else {
                resolve(value)
            }
        } catch (err) {
            reject({ isCanceled, err })
        }
    })

    return {
        promise: wrappedPromise,
        cancel: () => (isCanceled = true),
    }
}

const delay = (n: number) => new Promise((resolve) => setTimeout(resolve, n))

const usePreventClickOnDoubleClick = (onClick: any, onDoubleClick: any) => {
    const api = useCancellablePromises()

    const handleClick = () => {
        api.clearPendingPromises()
        const waitForClick = cancellablePromise(delay(300))
        api.appendPendingPromise(waitForClick)

        return waitForClick.promise
            .then(() => {
                api.removePendingPromise(waitForClick)
                onClick()
            })
            .catch((errorInfo) => {
                api.removePendingPromise(waitForClick)

                // fail gracefully
            })
    }

    const handleDoubleClick = () => {
        api.clearPendingPromises()
        onDoubleClick()
    }

    return [handleClick, handleDoubleClick]
}

export default usePreventClickOnDoubleClick
